module.exports = "/images/icon_favorite.svg?66dd896d46bcf0dfdfe06158f0941e1d";